module.exports = __webpack_public_path__ + "img/winwheel-base-red.ff356d14.png";